import { createAsyncThunk } from "@reduxjs/toolkit";

import { EquipmentResponse, RoomEquipmentRequest, WorkstationEquipmentRequest } from "../../api/generated";
import { Api } from "../../api";
import { withAxiosErrorHandling } from "redux/withAxiosErrorHandling";

export const getAllEquipment = createAsyncThunk("getAllEquipment", async (): Promise<EquipmentResponse[]> => {
  return Api.Equipment.getAllEquipment().then(({ data }) => {
    return data;
  });
});

export const postWorkstationEquipment = createAsyncThunk(
  "postWorkstationEquipment",
  async ({ workstationId, inventoryNumbers }: { workstationId: string; inventoryNumbers: string[] }): Promise<void> => {
    const request: WorkstationEquipmentRequest = {
      inventoryNumbers,
    };

    return Api.Equipment.saveEquipment(workstationId, request)
      .then(({ data }) => {
        return data;
      })
      .catch(withAxiosErrorHandling);
  },
);

export const postRoomEquipment = createAsyncThunk(
  "postRoomEquipment",
  async ({ roomId, inventoryNumbers }: { roomId: number; inventoryNumbers: string[] }): Promise<void> => {
    const request: RoomEquipmentRequest = {
      inventoryNumbers,
    };

    return Api.Equipment.saveRoomEquipment(roomId, request)
      .then(({ data }) => {
        return data;
      })
      .catch(withAxiosErrorHandling);
  },
);
